// extracted by mini-css-extract-plugin
export var dropdownArrow__icon = "LinkList-module--dropdownArrow__icon--9eb4f";
export var mobileHeader = "LinkList-module--mobileHeader--99a45";
export var nav_icon = "LinkList-module--nav_icon--ddc19";
export var navigation__searchBox = "LinkList-module--navigation__searchBox--1af40";
export var navigation__socialMedia = "LinkList-module--navigation__socialMedia--19e79";
export var navlist = "LinkList-module--navlist--5eb28";
export var serviceIcon__mainNav = "LinkList-module--serviceIcon__mainNav--20eb7";
export var services_linksList = "LinkList-module--services_linksList--03609";
export var workspaces_linksList = "LinkList-module--workspaces_linksList--7a5da";